import { Details } from "~/entities/Details";

export default function (stageDetail: Details): string {

  const { country, city, state, postalCode } = stageDetail;
  return (
    country &&
    city &&
    city.trim() &&
    ((country as any).code !== "US" || state) &&
    postalCode &&
    postalCode.trim()
  );
}